import { createModel, Models } from '@rematch/core'
import _ from 'lodash'
import axios from 'src/common/razzle-platform-components/axios'
import {handleErrors, isClient} from 'src/common/razzle-platform-components/utils'
import {BASE_URL, BASE_API_URL, REDIRECT_AFTER_REGISTER} from 'src/common/razzle-platform-user/configs'
// we need import storage when use getObjectItem, setObjectItem custom properties of localStorage
import 'src/common/razzle-platform-components/utils/storage'

export interface UserRootModel extends Models<UserRootModel> {
    userModel: any
}

const defaultState = {
    user: null
}

if (isClient) {
    // todo: getObjectItem is temporary solution waiting the new platform of react
    const user = localStorage.getObjectItem('user')
    const authenticationToken = localStorage.getItem('authentication_token')

    if (user && authenticationToken) {
        defaultState.user = {
            ...user,
            roles: user.roles.map(role => role.name)
        }
    }
}


export const userModel = createModel<UserRootModel>()({
    state: defaultState,
    reducers: {
        setUser(state, user) {
            return {
                ...state,
                user: {
                    ...user,
                    roles: user.roles.map(role => role.name)
                }
            }
        }

    },
    effects: (dispatch) => ({
        async login(payload) {
            try {
                const response = await axios.post(`${BASE_URL}login`, payload.data)
                const user = response.data
                // Set user and authentication_token in localstorage
                localStorage.setItem('authentication_token', user.authenticationToken)
                // todo: setObjectItem is temporary solution waiting the new platform of react
                localStorage.setObjectItem('user', user)
                // use onSuccess callback to handle the success request in the component
                dispatch.userModel.setUser(user)
                return user
            } catch (error) {
                throw handleErrors(error)
            }
        },
        async register(payload) {
            try {
                const response = await axios.post(`${BASE_URL}register-v1`, payload.data)

                if (REDIRECT_AFTER_REGISTER) {
                    localStorage.setItem('authentication_token', response.data.response.user.authenticationToken)
                    const userResponse = await axios.get(`${BASE_API_URL}users/${response.data.response.user.id}`)
                    const user = userResponse.data
                    localStorage.setObjectItem('user', user)
                    if (_.has(response.data, 'response.url')) {
                        window.location.href = response.data.response.url
                    }
                }

            } catch (error) {
                throw handleErrors(error)
            }
        },
        async fetchCurrentUser(payload={}, rootState) {
            try {
                if (!rootState.userModel.user || !rootState.userModel.user.id) {
                    return null
                }
                const params = payload.params || {}
                const response = await axios.get(`${BASE_API_URL}users/${rootState.userModel.user.id}`, { params })
                const user = response.data
                // Set user in localstorage
                // todo: setObjectItem is temporary solution waiting the new platform of react
                localStorage.setObjectItem('user', user)
                dispatch.userModel.setUser(user)
                return user
            } catch (error) {
                // use onError callback to handle the error request in the component
                throw handleErrors(error)
            }
        }
    })
})

